import { filterAtomDefaults } from '@/consts/defaults/filterAtomDefaults';
import { atom } from 'jotai';

export const minMinutesSelectedAtom = atom(filterAtomDefaults.minMinutes);
export const maxMinutesSelectedAtom = atom(filterAtomDefaults.maxMinutes);
